angular.module('logbook')
	.directive('tab', ['$timeout', '$route', '$location', function($timeout, $route, $location) {
		return {
			restrict: 'E',
			replace: true,
			require: '^lazyTabset',
			scope: {
				title: '@',
				templateUrl: '@'
			},
			link: function(scope, element, attrs, tabsetController) {
				tabsetController.addTab(scope);

				scope.helpSection = attrs.helpSection;

				scope.getDirectUrl = function() {
					return '/#' + $location.url().replace(/tab=([^&]*)/, 'tab=' + encodeURI(scope.title.toLowerCase()));
				};

				scope.select = function() {
					if (!tabsetController.selectTab(scope))
						return;
					scope.selected = false;
					tabsetController.setTabTemplate('');
					$timeout(function() { scope.selected = true; });
				};

				scope.$watch('selected', function() {
					if (scope.selected) {
						tabsetController.setTabTemplate(scope.templateUrl);
					}
				});
			},
			template:
				'<li ng-class="{active: selected}">' +
				'<a ng-href="{{getDirectUrl()}}" ng-click="$event.preventDefault(); select()">{{ title }}</a>' +
				'</li>'
		};
	}]
);
